import urlParser from 'url'

export const getAccountQueries = url => {
  const queries = urlParser.parse(url, true).query
  if (queries.done !== undefined)
    queries.done = encodeURIComponent(queries.done)
  return queries
}

export const buildAccountQueryString = url => {
  const queries = getAccountQueries(url)
  const permitQueries = ['done', 'referred_by', 'referredBy', 'serviceId', 'isSignUp']
  let queryString = ''

  if (Object.keys(queries).length > 0) {
    permitQueries.forEach(key => {
      if (!queries[key]) return
      queryString += queryString === '' ? '?' : '&'
      queryString += `${key}=${queries[key]}`
    })
  }

  return queryString
}

export const authUrlWithQuery = (url, provider) => {
  return `/auth/${provider}${buildAccountQueryString(url)}`
}

export const signUpUrlWithQuery = url => {
  return `/sign_up${buildAccountQueryString(url)}`
}

export const loginUrlWithQuery = url => {
  return `/login${buildAccountQueryString(url)}`
}
